// This file was auto-generated using: ./bin/mkVersion.sh
export const date = "Thu Mar  7 12:26:35 CET 2024, Lukas Fonti"
export const version = "1.4.1"
export const termsVersion = "1"
